import { render, staticRenderFns } from "./PeriodHeatmap.vue?vue&type=template&id=609ff32c&scoped=true&"
import script from "./PeriodHeatmap.vue?vue&type=script&lang=js&"
export * from "./PeriodHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./PeriodHeatmap.vue?vue&type=style&index=0&id=609ff32c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ff32c",
  null
  
)

export default component.exports